import React, { useContext, useMemo } from 'react'
import { format } from 'date-fns'
import GreenIcon from '@/assets/img__bio_alert__green.svg?react'
import RedIcon from '@/assets/img__bio_alert__red.svg?react'
import { IAlertEmergencyLiveItem, EmergencyAlertType } from '@/api/notification/getLiveEmergencyAlert.ts'
import { IAlertFallDetectionLiveItem } from '@/api/notification/getLiveFallDetectionAlert.ts'
import { EmergencyLiveAlertContext } from '@/pages/notification/emergency/EmergencyAlertModal.tsx'
import useQueryGetMe from '@/api/auth/getMe.ts'
import { useTranslation } from 'react-i18next'

export interface IProps {
    className?: string;
    item: IAlertEmergencyLiveItem | IAlertFallDetectionLiveItem;
    alertType: EmergencyAlertType;
}

const EmergencyAlertItem: React.FC<IProps> = ({ className, item, alertType }) => {
    const { t } = useTranslation()
    const { data: me } = useQueryGetMe()
    const { id, protectee, alert } = item;
    
    // 특정 이메일 계정인지 확인
    const isMaskingRequired = useMemo(() => {
        return me?.email === 'dbd_cm@clomental.com'
    }, [me?.email])
    
    const renderStatusIcon = useMemo(() => {
        if (alert?.taskManagerAt) {
            return <GreenIcon />
        } else {
            return <RedIcon />
        }
    }, [alert?.taskManagerAt])

    const { id: selectedId, setId } = useContext(EmergencyLiveAlertContext)

    const isSelected = useMemo(() => {
        return id == selectedId
    }, [id, selectedId])

    // 알림 타입에 따른 클래스 설정
    const getItemClassName = () => {
        const baseClass = `${className} rounded-[10px] flex justify-between items-center px-[20px] min-h-[40px] ${isSelected ? 'bg-main_b text-white' : 'bg-sub_b'} border ${!!alert?.isMyTask && selectedId != id ? 'border-sub_r' : 'border-transparent'} border-solid hover:border-main_b active:bg-main_b active:text-white cursor-pointer text-[14px]`
        
        // 낙상 알림일 경우 다른 스타일 적용 (예: 다른 색상의 테두리)
        if (alertType === EmergencyAlertType.FALL) {
            return `${baseClass} ${!isSelected ? 'border-l-4 border-l-[#8B5CF6]' : ''}`
        }
        
        return baseClass
    }

    // 알림 타입에 따른 아이콘 표시
    const getStatusLabel = () => {
        if (alert?.taskManagerAt) {
            return t('notification.sosModal.list.item.allotment')
        } else {
            return t('notification.sosModal.list.item.new')
        }
    }

    return <div
        className={getItemClassName()}
        onClick={() => setId(id)}>
        {renderStatusIcon}
        <p>{isMaskingRequired ? (protectee?.name ? protectee?.name.charAt(0) + '**' : '***') : protectee?.name}</p>
        <p>{format(alert?.createdAt, 'HH:mm:ss')}</p>
        <p>{getStatusLabel()}</p>
        {/* 알림 타입 표시 (낙상일 경우에만) */}
        {alertType === EmergencyAlertType.FALL && (
            <div className="px-2 py-1 bg-[#8B5CF6] text-white rounded-full text-xs">
                {t('notification.sosModal.list.item.fall')}
            </div>
        )}
    </div>
}

export default EmergencyAlertItem